import React from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    Typography,
    Divider,
    Box,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function CancellationSuccess({ open, onClose, onReenableSubscription }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ color: "black", pt: 4, pl: 4, fontSize: '24px', fontWeight: '600' }}>Subscription Cancelled</DialogTitle>
      <DialogContent sx={{ pl: 4, pb: 4, mr: 3, ml: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 4 }}>
          <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main' }} />
        </Box>
        <Typography sx={{ color: 'gray', mt: 1, mb: 4, pb: 2, fontSize: '18px', textAlign: 'center' }}>We're super sad to see you go. Your subscription has been successfully cancelled.</Typography>

        <Box
            role="region"
            aria-label="What happens next"
            sx={{
              bgcolor: 'grey.50',
              borderColor: 'grey.200',
              borderRadius: 2,
              px: 3,
              py: 2.5,
            }}
          >
            <Typography sx={{ fontWeight: 600, mb: 1, color: 'black' }}>
              What happens next:
            </Typography>
            <List
              component="ul"
              dense
              sx={{
                pl: 3,
                listStyleType: 'disc',
                // ensure markers show even if a reset set list-style:none
                '& li': { display: 'list-item', listStyleType: 'disc', paddingLeft: 0 },
              }}
            >
              <ListItem component="li" disableGutters>
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ color: 'grey', fontSize: 16 }}>
                      • You'll continue to have premium access until the end of your billing cycle
                    </Typography>
                  }
                />
              </ListItem>

              <ListItem component="li" disableGutters>
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ color: 'grey', fontSize: 16 }}>
                      • No more charges will be made to your account
                    </Typography>
                  }
                />
              </ListItem>

              <ListItem component="li" disableGutters>
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ color: 'grey', fontSize: 16 }}>
                      • You'll receive a confirmation email shortly
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </Box>
        
        <Typography variant="caption" sx={{ color: 'gray', mt: 3, pb: 2, fontSize: '12px', textAlign: 'center', display: 'block' }}>If you change your mind, you can reactivate your subscription <Typography variant="caption" onClick={onReenableSubscription} sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>here</Typography>.</Typography>
      </DialogContent>
      <Divider /> 
      <DialogActions sx={{ pb: 4, pr: 4, pt: 3 }}>
        <Button onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>  
  );
}

export default CancellationSuccess;
